import { useContext } from 'react';
import HeadRow from './HeadRow';
import HeadCell from './HeadCell';

import { TableContext } from '../../TableContext';

export default function TableHead() {
  const ctx = useContext(TableContext);
  return (
    <div
      style={{
        width: '100%',
        backgroundColor: '#003B58',
        padding: '20px 26px',
        ...ctx.headerStyles
      }}
    >
      <HeadRow>
        {ctx?.columns()?.map((column) => (
          <HeadCell key={column.id} alignment={column?.alignment}>
            {column.name()}
          </HeadCell>
        ))}
      </HeadRow>
    </div>
  );
}
